<template>
    <marketingLead />
</template>
  
<script>
import marketingLead from "./marketingLead.vue";
// import headHunting from "./headHunting.vue"
export default {
  components: {
    marketingLead
  },
  data() {
    return {
      
    }
  },
  created() {
    
  },
  methods: {
    
  }
}
</script>

<style scoped>

</style>

<style >
</style>